module.exports = __webpack_public_path__ + "static/media/share-in-weixin.55512e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/images/share-in-weixin.png
// module id = 603
// module chunks = 12